module.exports = __webpack_public_path__ + "media/icons/search-a9f150a1.svg";